import {
  LEAD_SOURCE_LABELS,
  LEAD_SOURCE_CODES,
  LEAD_STATUSES,
  LEAD_STATUS_LABELS,
} from '@marketing-hub/shared';
import type { LeadFilterState } from './leadQuery';
import styles from './Leads.module.css';

type Props = {
  filters: LeadFilterState;
  onChange: (next: LeadFilterState) => void;
};

export function LeadFilters({ filters, onChange }: Props) {
  return (
    <div className={styles.filters}>
      <label className={styles.filterField}>
        <span className={styles.filterLabel}>Zoeken</span>
        <input
          className={styles.filterInput}
          value={filters.q}
          onChange={(e) => onChange({ ...filters, q: e.target.value, page: 1 })}
          placeholder="Naam, bedrijf, e-mail"
        />
      </label>
      <label className={styles.filterField}>
        <span className={styles.filterLabel}>Status</span>
        <select
          className={styles.filterInput}
          value={filters.status}
          onChange={(e) => onChange({ ...filters, status: e.target.value, page: 1 })}
        >
          <option value="">Alle</option>
          {LEAD_STATUSES.map((s) => (
            <option key={s} value={s}>
              {LEAD_STATUS_LABELS[s]}
            </option>
          ))}
        </select>
      </label>
      <label className={styles.filterField}>
        <span className={styles.filterLabel}>Bron</span>
        <select
          className={styles.filterInput}
          value={filters.source}
          onChange={(e) => onChange({ ...filters, source: e.target.value, page: 1 })}
        >
          <option value="">Alle</option>
          {LEAD_SOURCE_CODES.map((c) => (
            <option key={c} value={c}>
              {LEAD_SOURCE_LABELS[c]}
            </option>
          ))}
        </select>
      </label>
      <label className={styles.filterField}>
        <span className={styles.filterLabel}>Tag</span>
        <input
          className={styles.filterInput}
          value={filters.tag}
          onChange={(e) => onChange({ ...filters, tag: e.target.value, page: 1 })}
        />
      </label>
    </div>
  );
}
